import { SelectionModel } from '@angular/cdk/collections';
import { Component, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { EventInvitation, EventInvitationStatus, EventInvitationStatusesList, HuntingEvent, Person } from 'diwimamodelweb/lib';
import { deepCopy } from 'diwimamodelweb/lib/utils/obejct-diff';
import { BehaviorSubject } from 'rxjs';
import { EventInviteSharedService } from 'src/app/cockpit/event-invitation/event-invite-shared.service';
import { GenericDialogComponent } from '../generic-dialog/generic-dialog.component';
import { UserFeedbackService } from '../user-feedback.service';
import * as XLSX from 'xlsx';
import * as moment from 'moment'
import { environment } from 'src/environments/environment';
import { ObjectExportService, ExportMappings } from '../object-export.service';
import { copyTextToClipboard } from 'src/app/cockpit/event-invitation/mng-person/mng-person.component';
import { AfterViewInit } from '@angular/core';
import { MatSort } from '@angular/material/sort';

const toTableData = (data: EventInvitation[], availablePerson: Person[], events: HuntingEvent[]): any => {

  data.sort((a, b) => {
    return a?.personAnzeigeName?.localeCompare(b?.personAnzeigeName)
  })
  let tableData: any[] = []
  for (let person of availablePerson) {
    let obj = {}
    for (let event of events) {
      const invitation = data?.find(el => el.eventId == event.identifier && el.personId == person.identifier)
      obj[event.name] = invitation ? invitation : {}
      Object.assign(obj[event.name], { person }, { event })
    }
    tableData.push(
      {
        Person: person.anzeigeName,
        ...obj
      }
    )
  }

  return tableData
}

@Component({
  selector: 'app-person-event-overview-table',
  templateUrl: './person-event-overview-table.component.html',
  styleUrls: ['./person-event-overview-table.component.scss']
})
export class PersonEventOverviewTableComponent implements OnInit {

  @Input() set eventInvites(invites: EventInvitation[]) {
    this.inv = invites
    this.makeTable()
  }
  @Input() set persons(p: Person[]) {
    this.pers = p
    this.makeTable()
  }
  @Input() set huntingEvents(e: HuntingEvent[]) {
    const today = new Date().getTime()
    e.sort((a, b) => {
      const aDiff = Math.abs(new Date(a?.date ?? 0).getTime() - today)
      const bDiff = Math.abs(new Date(b?.date ?? 0).getTime() - today)
      return aDiff - bDiff
    })
    this.events = e
    this.makeTable()
  }
  inv: EventInvitation[]
  pers: Person[]
  events: HuntingEvent[]
  makeTable = () => {
    if (this.pers && this.inv && this.events) {
      const tData = toTableData(this.inv, this.pers, this.events)
      this.originalTableData = tData?.sort((a, b) => a?.Person?.toLowerCase().localeCompare(b?.Person?.toLowerCase()));
      const fValue = this.tableFilterForm?.value
      this.filterTable(fValue?.textFilter, fValue?.statusFilter)
    }
  }
  value: string
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataSource: MatTableDataSource<EventInvitation>
  dataSourceForExcelExport: MatTableDataSource<EventInvitation>
  selection = new SelectionModel<EventInvitation>(true, []);
  show = false

  tableFilterForm: FormGroup
  originalTableData: any[]
  filteredTableData$ = new BehaviorSubject<any>(undefined)

  paginatorPageSizeOptions = [25, 50, 100]
  statuses = EventInvitationStatusesList
  locale: string
  columnsToDisplay: string[]
  columnsToDisplayWOPerson: string[]

  constructor(
    private translateService: TranslateService,
    private userFeedbackService: UserFeedbackService,
    private eventInviteSharedService: EventInviteSharedService,
    private formBuilder: FormBuilder,
    private objectExportService: ObjectExportService,
    private translate: TranslateService,
    private renderer: Renderer2
  ) { }

  ngOnInit(): void {
    this.tableFilterForm = this.formBuilder.group({
      textFilter: [],
      statusFilter: []
    })
    this.tableFilterForm.valueChanges.subscribe((value) => {

      const { textFilter, statusFilter } = value
      this.value = textFilter
      this.filterTable(textFilter, statusFilter)
    })
    this.filteredTableData$.subscribe((data) => {
      this.createTable(data)
    })
  }

  ngAfterViewInit(): void {
    if (this.dataSource) {
      this.dataSource.sort = this.sort;
    }
  }

  filterTable(searchString: string | undefined, statuses: string[] | undefined) {
    if (!searchString && (!statuses || statuses.length == 0)) {

      this.filteredTableData$.next(this.originalTableData)
    } else {
      let str = searchString
      if (searchString) str = searchString.toLowerCase()

      const filtered = this.originalTableData.filter(el => {
        let processingStatuses: Map<string, boolean> = new Map()
        for (let [key, value] of Object.entries(el)) {
          const v: any = value
          if (v?.processingStatus) processingStatuses.set(v.processingStatus, true)
        }
        const personName = el.Person?.toLowerCase()
        if (str && (statuses && statuses.length > 0)) {
          let inSt = false
          for (let st of statuses) {
            if (processingStatuses.get(st)) inSt = true
          }
          return personName ? personName.includes(str) && inSt : false
        } else if (str && (!statuses || statuses.length == 0)) {
          return personName ? personName.includes(str) : false
        } else if (!str && statuses) {
          let inSt = false
          for (let st of statuses) {
            if (processingStatuses.get(st)) inSt = true
          }
          return inSt
        }
      })

      this.filteredTableData$.next(filtered)
    }
  }

  createTable(data: any[]) {
    this.show = false

    if (data?.length > 0) {
      const toDisplay = new Set<string>()
      toDisplay.add("Person")
      toDisplay.add("invitation_link")
      const events = Object.keys(data[0]).filter(k => k !== 'Person')
      for (let key of events) {
        toDisplay.add(key)
      }
      this.columnsToDisplay = [...toDisplay]
      this.columnsToDisplayWOPerson = [...toDisplay].slice(2, toDisplay.size)
      this.dataSource = new MatTableDataSource(data)
      this.dataSource.paginator = this.paginator
      this.dataSource.sort = this.sort
      this.dataSource.sortingDataAccessor = (item, property) => {
        if (property === 'Person') return item['Person']?.toLowerCase()
        return item[property]?.processingStatus ?? ''
      }
      this.show = true
      const ref = document.getElementById("table-person-invite")
      if (ref) this.renderer.setStyle(ref, "width", "100%")
    } else {
      this.columnsToDisplay = []
      this.columnsToDisplayWOPerson = []
      this.dataSource = new MatTableDataSource([])
      this.dataSource.paginator = this.paginator
      this.dataSource.sort = this.sort
    }
  }

  async editStatus(element, st) {

    if (element?.processingStatus) {
      // edit process Status .. await result... 
      try {
        const sbSuccessSave = await this.translateService.get('changes_saved').toPromise()
        this.userFeedbackService.loading.emit(true)
        const oldInvitation = deepCopy(element, element.replacerFn)
        const newInvitation = Object.assign({}, oldInvitation, { processingStatus: st })
        await this.eventInviteSharedService.updateSingleInvitation(oldInvitation, newInvitation)
        this.userFeedbackService.loading.emit(false)
        this.userFeedbackService.showSnackBar.emit(sbSuccessSave)
        element.processingStatus = st
      } catch (error) {
        this.userFeedbackService.loading.emit(false)
        console.error(error)
        this.userFeedbackService.showDialog.emit(
          {
            entryComponent: GenericDialogComponent,
            title: "Error",
            message: error?.error?.message ? error?.error?.message : JSON.stringify(error),
          }
        )
      }
    } else {
      // no status yet...  create new
      const { person, event } = element
      try {
        const nInvite = EventInvitation.builder.newEventIvitation(event, person)
        nInvite.setProcessingStatus(st)
        this.userFeedbackService.loading.emit(true)
        await this.eventInviteSharedService.saveNewInvitations([nInvite])
        this.userFeedbackService.loading.emit(false)
        const sbSuccessSave = await this.translateService.get('changes_saved').toPromise()
        this.userFeedbackService.showSnackBar.emit(sbSuccessSave)
      } catch (error) {
        this.userFeedbackService.loading.emit(false)
        console.error(error)
        this.userFeedbackService.showDialog.emit(
          {
            entryComponent: GenericDialogComponent,
            title: "Error",
            message: error?.error?.message ? error?.error?.message : JSON.stringify(error),
          }
        )
      }
    }
  }

  async exportAllInvitations() {
    const list = this.inv
    if (list.length > 0) {
      const nList = await this.objectExportService.toXlsxExport(list, ExportMappings.eventInvitationExport)

      // const ws: XLSX.WorkSheet=XLSX.utils.table_to_sheet(this.table.nativeElement);
      const ws = XLSX.utils.json_to_sheet(nList)
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      
      const exportName = await this.translateService.get('export_name_all_invitations').toPromise()
      const date = new Date()
      
      const fileName = `${moment(date).format('YYYYMMDD')}_${exportName}`
      XLSX.utils.book_append_sheet(wb, ws, exportName.length > 29 ? exportName.substring(0,29) : exportName);
    
      /* save to file */
      XLSX.writeFile(wb, `${fileName}.xlsx`);
    } else {
      const txt = await this.translateService.get('snack_no_approved_invitations').toPromise()
      this.userFeedbackService.showSnackBar.emit(txt)
    }
  }

  async exportApprovedInvitations() {
    // check if any approved... 
    const date = new Date()
    const list = this.inv.filter(
      el => el.processingStatus == EventInvitationStatus.APPROVED && el?.eventDate?.getTime() >= date?.getTime()
    )
    if (list.length > 0) {
      const nList = await this.objectExportService.toXlsxExport(list, ExportMappings.eventInvitationExport)

      // const ws: XLSX.WorkSheet=XLSX.utils.table_to_sheet(this.table.nativeElement);
      const ws = XLSX.utils.json_to_sheet(nList)
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      
      const exportName = await this.translateService.get('export_invitations_approved').toPromise()      
      const fileName = `${moment(date).format('YYYYMMDD')}_${exportName}`
      XLSX.utils.book_append_sheet(wb, ws, exportName.length > 29 ? exportName.substring(0,29) : exportName);
    
      /* save to file */
      XLSX.writeFile(wb, `${fileName}.xlsx`);

      const title_dialog_update_status_to_pending = await this.translateService.get('title_dialog_update_status_to_pending').toPromise()
      const msg_dialog_update_status_to_pending = await this.translateService.get('msg_dialog_update_status_to_pending').toPromise()
      this.userFeedbackService.showDialog.emit(
        {
          entryComponent: GenericDialogComponent,
          title: title_dialog_update_status_to_pending,
          message: msg_dialog_update_status_to_pending,
          cancleCallback: () => {

          },
          positiveCallback: () => {
            this.updateInvitations(list)
          }
        })
    } else {
      const txt = await this.translateService.get('snack_no_approved_invitations').toPromise()
      this.userFeedbackService.showSnackBar.emit(txt)
    }
  }

  async exportFilteredInvitations() {
    // export selection ... 
    const list = []
    this.dataSource.data?.forEach((d) => {
      for (let [key, value] of Object.entries(d)) {
        if (key == "Person") continue
        if (Object.keys(value).includes("identifier")) list.push(value)
      }
    })
    // convert to json that converts to sheet...
    if (list.length > 0) {
      const nList = await this.objectExportService.toXlsxExport(list, ExportMappings.eventInvitationExport)

      // const ws: XLSX.WorkSheet=XLSX.utils.table_to_sheet(this.table.nativeElement);
      const ws = XLSX.utils.json_to_sheet(nList)
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      
      const exportName = await this.translateService.get('export_name_filtered_invitations').toPromise()
      const date = new Date()
      
      const fileName = `${moment(date).format('YYYYMMDD')}_${exportName}`
      XLSX.utils.book_append_sheet(wb, ws, exportName.length > 29 ? exportName.substring(0,29) : exportName);
    
      /* save to file */
      XLSX.writeFile(wb, `${fileName}.xlsx`);
    } else {
      const txt = await this.translateService.get('snack_no_approved_invitations').toPromise()
      this.userFeedbackService.showSnackBar.emit(txt)
    }
  }

  async updateInvitations(invitations: EventInvitation[]) {

    try {
      this.userFeedbackService.loading.emit(true)
      const promiseArray = []
      invitations.forEach((element) => {
        const oldInvitation = deepCopy(element, element.replacerFn)
        element.setProcessingStatus(EventInvitationStatus.PENDING)
        const newInvitation = deepCopy(element, element.replacerFn)
        promiseArray.push(
          this.eventInviteSharedService.updateSingleInvitation(oldInvitation, newInvitation)
        )
      });
      await Promise.all(promiseArray)
      this.userFeedbackService.loading.emit(false)
      const sbSuccessSave = await this.translateService.get('changes_saved').toPromise()
      this.userFeedbackService.showSnackBar.emit(sbSuccessSave)
    } catch (error) {
      this.userFeedbackService.loading.emit(false)
      console.error(error)
      this.userFeedbackService.showDialog.emit(
        {
          entryComponent: GenericDialogComponent,
          title: "Error",
          message: error?.error?.message ? error?.error?.message : JSON.stringify(error),
        }
      )
    }
  }

  async getInvitationLink(element: any) {
    const keysToChoose = Object.keys(element).filter(el => el != "Person")
    if (keysToChoose && keysToChoose.length > 0) {
      try {
        const person: Person = element[keysToChoose[0]].person
        await copyTextToClipboard(`${environment.invitationURL}/inv/${person.invitationRef}`) 
        const text = await this.translate.get('snack_success_copy').toPromise()
        this.userFeedbackService.showSnackBar.emit(text)
      } catch (error) {
        const text = await this.translate.get('snack_failure_copy').toPromise()
        this.userFeedbackService.showSnackBar.emit(text)
      }
    } else {
      const text = await this.translate.get('snack_failure_copy').toPromise()
      this.userFeedbackService.showSnackBar.emit(text)
    }  
  }
}
